// @ts-nocheck
import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { Card } from '@/components';
import { CLASSES } from '@/constants/classes';
import LogoLibraryList from './LogoLibraryList';
import '@/style/containers/LogoLibrary/style.scss'

export default function LogoLibrary() {
  return (
    <div className={classNames(CLASSES.PREFERENCES_PAGE_INSIDE_CONTENT)}>
      <LogoLibraryCard>
        <LogoLibraryList />
      </LogoLibraryCard>
    </div>
  );
}

const LogoLibraryCard = styled(Card)`
  padding: 0;
`;
